import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { InvestmentSection } from './components/InvestmentSection';
import { PortfolioSection } from './components/PortfolioSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { AboutUsPage } from './pages/AboutUsPage';
import { InvestmentPage } from './pages/InvestmentPage';
import { ContactPage } from './pages/ContactPage';
import { PortfolioPage } from './pages/PortfolioPage';
import { TestimonialsPage } from './pages/TestimonialsPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { TermsOfUsePage } from './pages/TermsOfUsePage';
import { DisclosuresPage } from './pages/DisclosuresPage';
import { ScrollToTop } from './components/ScrollToTop';
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1">
        <div className="font-sans text-gray-800 bg-white" data-id="element-2">
          <Routes data-id="element-3">
            <Route path="/about-us" element={<AboutUsPage data-id="element-5" />} data-id="element-4" />
            <Route path="/investments" element={<InvestmentPage data-id="element-7" />} data-id="element-6" />
            <Route path="/contact" element={<ContactPage data-id="element-9" />} data-id="element-8" />
            <Route path="/portfolio" element={<PortfolioPage data-id="element-11" />} data-id="element-10" />
            <Route path="/testimonials" element={<TestimonialsPage data-id="element-13" />} data-id="element-12" />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage data-id="element-15" />} data-id="element-14" />
            <Route path="/terms-of-use" element={<TermsOfUsePage data-id="element-17" />} data-id="element-16" />
            <Route path="/disclosures" element={<DisclosuresPage data-id="element-19" />} data-id="element-18" />
            <Route path="/" element={<>
                  <Header data-id="element-21" />
                  <main data-id="element-22">
                    <HeroSection data-id="element-23" />
                    <AboutSection data-id="element-24" />
                    <InvestmentSection data-id="element-25" />
                    <PortfolioSection data-id="element-26" />
                    <TestimonialsSection data-id="element-27" />
                    <ContactSection data-id="element-28" />
                  </main>
                  <Footer data-id="element-29" />
                </>} data-id="element-20" />
          </Routes>
        </div>
      </ScrollToTop>
    </BrowserRouter>;
}